import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import Settings from './Settings';
import Auth from './Auth';
import Menu from './Menu';
import Packages from './Packages';
import UserManage from './UserManage';
import User from './User';
import Batch from './Batch';
import MasterDriver from './MasterDriver';
import MasterVehicle from './MasterVehicle';
import Notif from './Notif';
import ImportExcel from './ImportExcel';


const reducers = combineReducers({
    routing: routerReducer,
    settings: Settings,
    auth: Auth,
    batch: Batch,
    menu: Menu,
    packages: Packages,
    usermanage: UserManage,
    user: User,
    masterDriver: MasterDriver,
    masterVehicle: MasterVehicle,
    notif: Notif,
    importExcel: ImportExcel
});

export default reducers;



// WEBPACK FOOTER //
// ./reducers/index.js